import { gql } from "@apollo/client";

const deletePartner = gql`
  mutation DeletePartner($id: ID!) {
    deletePartner(id: $id)
  }
`;

export default deletePartner;
